<template>
	<v-container fluid >
		<!-- <v-card color="error">
			<v-card-text class="text-center">
				Just nu upplever vi driftstörningar i Crona Lön. Felsökning pågår och vi arbetar för att åtgärda problemet så snart som möjligt.
			</v-card-text>
		</v-card> -->

		<v-row dense align="center" justify="center">
			<v-col cols="12" sm="10" md="8" lg="5" xl="4">
				<v-img
								:src="$buildBrandedAssetsURL($vuetify.theme.dark ? '/logos/white.png' : '/logos/dark.png')"
								:lazy-src="$buildBrandedAssetsURL($vuetify.theme.dark ? '/logos/white.png' : '/logos/dark.png')"
								:max-height="175"
								contain
								class="mb-5 mt-5"
				/>
				<v-card outlined>
					<OpenIDConnect v-if="$route.name === 'OpenIDConnect'" />
					<v-tabs v-else v-model="tab" grow slider-color="accent" :color="$vuetify.theme.dark ? 'accent' : 'primary'">
						<template v-for="(item, index) in tabs">
							<v-tab :key="index">{{item.label}}</v-tab>
						</template>

						<template v-for="(item, index) in tabs">
							<v-tab-item :value="index">
								<v-divider></v-divider>
								<component class="pt-3" v-bind:is="item.component" v-bind="item.params"/>
							</v-tab-item>
						</template>

					</v-tabs>
				</v-card>

			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import LocalStorage from '../lib/LocalStorage.js';

import ElectronicIDLogin from './LoginForms/ElectronicIDLogin.vue';
import UsernamePassword  from './LoginForms/UsernamePassword.vue';
import OpenIDConnect     from './LoginForms/OpenIDConnect.vue';

export default {
	name: 'Login',
	data: () => ({
		tab: parseInt(LocalStorage.get('LoginMethod'), 10) || null,
	}),

	mounted() {
		if(this.tab > this.tabs.length - 1) {
			this.tab = 0;
		}
	},

	computed: {
		tabs() {
			return [
				{label: 'E-legitimation', component: 'ElectronicIDLogin', params: {}},
				{label: 'Användarnamn', component: 'UsernamePassword', params: {}},
			];
		},
	},

	components: {
		UsernamePassword,
		ElectronicIDLogin,
		OpenIDConnect,
	},
}
</script>

<style scoped>
	::v-deep(.v-slide-group__prev, .v-slide-group__next) {
		display: none !important;
	}
</style>
